// Third-party imports
import $ from 'jquery';

// Module name
export const MODULE_NAME = 'tab';

export let global_vars = {};

export function initialize() {
    let tabActiveClass = 'tab--active';
    let tabItemActiveClass = 'tabItem--active';

    $('.tab, .tab-mobile').on('click', e => {
        let clickedTabClass = $(e.target).attr('class');
        if (clickedTabClass === 'tab tab--disabled') {
            return;
        }

        let thisTab = $(e.target);
        let tabs = thisTab.closest('.tabs');
        let activeTab = tabs.find('.tab--active');
        let activeTabItem = tabs.find('.tabItem--active');
        let targetIndex = thisTab.data('trigger');

        if (thisTab.hasClass('tab-mobile')) {
            activeTab.not(this).removeClass(tabActiveClass);
            activeTabItem
                .not(`.tabItem${targetIndex}`)
                .removeClass(tabItemActiveClass);
        } else {
            activeTab.removeClass(tabActiveClass);
            activeTabItem.removeClass(tabItemActiveClass);
        }

        thisTab.toggleClass(tabActiveClass);
        tabs.find(`.tabItem${targetIndex}`).toggleClass(tabItemActiveClass);
    });

    $('ul.tabs').each(function() {
        let links = $(this).find('a');
        let active = links.first().addClass('active');
        let selected = links.first().attr('aria-selected', true);
        let content = $(active.attr('href'));
        links.not(':first').each(function() {
            $($(this).attr('href')).hide();
        });
        $(this)
            .find('a')
            .on('click', e => {
                active.removeClass('active');
                content.hide();
                selected.attr('aria-selected', false);
                active = !$(e.target).hasClass('wvtab-link')
                    ? $(e.target).parent()
                    : $(e.target);
                content = $(active.attr('href'));

                const slideIndex = $(active).data('slide-index');
                $(`#slider-${slideIndex}`).slick('refresh');
                active.addClass('active').attr('aria-selected', true);
                content.show();
                return false;
            });
    });

    // Ensure Gift Catalogue: Get Started mobile tab cards are the same height
    $('#gsHeightContainer').each(function() {
        let tallest = 0;
        $('.howto-card-body', this).each(function() {
            if ($(this).height() > tallest) {
                tallest = $(this).height();
            }
        });
        $('.howto-card-body', this).height(tallest);
    });
}
